import { IOptimizationPost } from '../../../types/optimization'
import { simulationApi } from '../../apiInstances'

export default {
  optimize(payload: IOptimizationPost) {
    return simulationApi.post('/optimization/', payload)
  },
}
